var $e83474afc7c44eea$exports = {};
$e83474afc7c44eea$exports = {
  "collapse": "Restr\xE2nge\u021Bi",
  "expand": "Extinde\u021Bi"
};
export { $e83474afc7c44eea$exports as default };